var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9167 3.33333H15.8334V5H4.16675V3.33333H7.08341L7.91675 2.5H12.0834L12.9167 3.33333ZM6.66675 17.5C5.75008 17.5 5.00008 16.75 5.00008 15.8333V5.83333H15.0001V15.8333C15.0001 16.75 14.2501 17.5 13.3334 17.5H6.66675Z",
    fill: "currentColor",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon_trash.d7625ed819c1061c47edbc553dc8400e.svg";
export { ForwardRef as ReactComponent };